module.exports = __webpack_public_path__ + "img/wgykh.6263f8a5.png";